import React from 'react';
import BootstrapButton from 'react-bootstrap/Button';
import classnames from 'classnames';

import styles from './Button.module.scss';

const Button = ({ children, className, ...props }) => (
  <BootstrapButton {...props} bsPrefix="boon-btn" className={classnames(styles.boonBtn, className)}>
    {children}
  </BootstrapButton>
);

export default Button;
